import React from 'react';
import AdGuard from './AdGuard';

const Features = () => {
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <h1>Features</h1>
      <AdGuard adSlot="" />
      <p>
        PDF Blink offers a comprehensive set of client-side PDF utilities designed to make common
        PDF tasks fast, private, and easy. All main tools run in the browser using lightweight
        libraries so files never leave your computer unless you explicitly download or share them.
      </p>

      <h2>Convert</h2>
      <p>
        Convert between formats quickly — turn text or images into professional PDFs, or extract
        text to create Word documents. Built-in conversion supports common workflows such as image
        to PDF, text-to-PDF, and Excel-to-PDF conversions for simple data export.
      </p>

      <h2>Merge & Split</h2>
      <p>
        Merge multiple PDFs into a single document and split large PDFs into smaller files. These
        tools are useful when assembling reports or extracting specific pages for sharing. The
        operations are fast and operate page-by-page to reduce memory usage.
      </p>

      <h2>Edit & Modify</h2>
      <p>
        Edit PDF content in-browser: add watermarks, crop pages, delete or reorder pages, and
        add page numbers. The editor supports adding text overlays and basic annotations to help
        brand or personalize documents before download.
      </p>

      <h2>Compress & Optimize</h2>
      <p>
        Reduce file size while preserving readability. Compression options let you balance image
        quality and file size so you can prepare PDFs for email or web upload without losing
        critical detail.
      </p>

      <h2>Privacy-focused</h2>
      <p>
        Many of PDF Blink's features run entirely within the browser so your files don't get
        uploaded to third-party servers by default. This reduces privacy risk and is ideal for
        sensitive documents; always read the privacy policy for details on analytics or ads.
      </p>

      <h2>Developer-friendly</h2>
      <p>
        The site uses well-known open libraries under permissive licenses. If you need to embed or
        adapt functionality, the codebase is modular — each tool is a small React component that
        you can reuse or extend in your own projects.
      </p>

      <h2>Compatibility & Export</h2>
      <p>
        Works in modern browsers (Chrome, Edge, Firefox, Safari). Downloads are produced as
        standard PDF files compatible with popular PDF viewers and print workflows.
      </p>

      <p>
        If you want a feature added or need help integrating our tools into your workflow, use
        the Contact page — we welcome feedback and feature requests.
      </p>

      <h2>More about using PDF Blink</h2>
      <p>
        PDF Blink is built for people who want predictable results without complexity. Whether
        you are consolidating meeting notes into a single document, compressing large scans for
        fast sharing, or preparing polished PDFs for printing, the suite focuses on practical
        controls and sensible defaults so tasks finish quickly. Our client-side emphasis means
        files stay on your device during processing which reduces privacy risk and accelerates
        conversions because there's no upload latency. We aim to balance power and simplicity —
        providing options like page size and orientation settings, image quality sliders for
        compression, and drag-and-drop ordering for mergers while keeping the interface uncluttered.
        This approach helps novice users finish common tasks immediately while giving power users
        the single-click controls they expect. If you are working with complex documents or need
        batch handling beyond what's available here, the Contact page provides a way to request
        guidance or integrations tailored to your workflow.
      </p>
    </div>
  );
};

export default Features;
